module.exports = __webpack_public_path__ + "static/media/logo-bitda.d944406b.png";